<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined/>
                            <a><span>Funcionalidades Específicas</span></a>
                        </a-breadcrumb-item>

                        <a-breadcrumb-item>{{ isEditMode ? 'Editar' : 'Listar' }}</a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <template #extra>
                    <a-button @click="isEditMode = true" v-if="!isEditMode" style="color: white; background-color: blue">
                        Editar Funcionalidades
                    </a-button>
                    <a-button @click="update" v-if="isEditMode" style="color: white; background-color: green">
                        Salvar
                    </a-button>
                </template>
                <a-row justify="center">
                    <a-col :span="16">
                        <a-table
                            :columns="columns"
                            :data-source="dataSource"
                            :rowKey="record => record.id"
                            bordered
                        >
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'description'">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <a-input v-if="isEditMode" v-model:value="record[column.dataIndex]" type="text" style="margin-right: 20px" />
                                        <span v-else>{{ record[column.dataIndex] }}</span>
                                        <a-switch v-model:checked="record['status']" :disabled="!isEditMode" />
                                    </div>
                                </template>
                            </template>
                        </a-table>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </a-spin>

</template>

<script setup>
import {h, onMounted, ref} from "vue";
import {FileOutlined, PlusOutlined} from "@ant-design/icons-vue";
import {notification} from "ant-design-vue";
import { openNotification } from "../../../../utils/utilities";

const columns = ref([
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
        },
]);
const isEditMode = ref(false)

const dataSource = ref();
const spinning = ref(false);
const route = '/api/configurations/specific-functionalities';

onMounted(async () => {
    await load();
});

const load = async () => {
    try {
        spinning.value = true
        const response = await window.axios.get(route);
        dataSource.value = response.data.data;
        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }
}

const update = async () => {
    try {
        spinning.value = true
        let response = await window.axios.put(route, dataSource.value)
        spinning.value = false
        openNotification('success', response.data.message)
        await (new Promise(resolve => setTimeout(resolve, 500)));
        window.location.reload()
    } catch (error) {
        spinning.value = false
        openNotification('error', error.message)
    }
}
</script>

<style scoped>
.child-table-container {
    display: flex;
    justify-content: center; /* Centraliza horizontalmente */
    width: 100%;
}

.child-table {
    border-collapse: collapse;
    width: 60%; /* Define um tamanho para não ficar muito larga */
    max-width: 600px;
    border: 1px solid #ddd;
}

.child-table th, .child-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}
</style>
